__turbopack_context__.v({
  "className": "noto_sans_kr_9076e8be-module__xayuOG__className",
  "variable": "noto_sans_kr_9076e8be-module__xayuOG__variable",
});
